import { Component, inject, signal } from '@angular/core';
import { NavigationEnd, NavigationStart, RouterOutlet } from '@angular/router';

import { GoogleTagManagerService } from 'angular-google-tag-manager';
import { distinctUntilChanged, filter } from 'rxjs';

import { CamDynamicTranslationService } from '@camelot/core';
import { NotificationBoxComponent } from '@camelot/notification';
import { LogoComponent, OverlayService } from '@camelot/ui';
import { CAM_AUTH_TOKEN } from '@camelot/user';

import { BaseComponent } from './features/core/abstract/baseComponent';
import { AppPermissionsBypassService } from './services/permissions-bypass.service';
import { AppTranslationApplication } from './services/translation.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
  imports: [LogoComponent, NotificationBoxComponent, RouterOutlet],
})
export class AppComponent extends BaseComponent {
  title = 'merlin';

  readonly isTranslationReady = signal(false);

  private _authService = inject(CAM_AUTH_TOKEN);
  private _gtmService = inject(GoogleTagManagerService);
  private _overlayService = inject(OverlayService);
  private _permissionsBypassService = inject(AppPermissionsBypassService);

  constructor() {
    super();
    this._permissionsBypassService.init();
    CamDynamicTranslationService.getInstance();
    AppTranslationApplication.getInstance()
      .isReceived$.pipe(
        distinctUntilChanged(),
        filter(isRecieved => isRecieved)
      )
      .subscribe({
        next: () => this.isTranslationReady.set(true),
      });
    this._authService.load();

    this._router.events.subscribe(event => {
      if (event instanceof NavigationStart) {
        this._overlayService.closeAll();
      } else if (event instanceof NavigationEnd) {
        const gtmTag = {
          event: 'page',
          pageName: event.url,
        };

        this._gtmService.pushTag(gtmTag);
      }
    });
  }
}
